import WallCommon from "./wallCommon";

export default class LeftWallSplitter extends WallCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'left_wall_splitter';
    this.partName = 'Left Wall Splitter';
    this.translateId = "visualizer.bathroom.walls.left_wall_splitter";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
    // this.hasAdditionalParts = true;
    // this.additionalPartPartId = "split_wall_crop";
  }
}

